import posthog from 'posthog-js';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

let initialized = false;

export function initAnalytics() {
  if (initialized || !posthogKey) return;
  posthog.init(posthogKey, {
    api_host: posthogHost || 'https://us.i.posthog.com',
    autocapture: false,
  });
  initialized = true;
}

export function trackSignupCompleted(betaCode: string) {
  posthog.capture('signup_completed', { betaCode });
}

export function trackTripCreated(destination: string, crewSize: number) {
  posthog.capture('trip_created', { destination, crewSize });
}

export function trackPaywallViewed(tripId: string) {
  posthog.capture('paywall_viewed', { tripId });
}

export function trackPaymentCompleted(tripId: string) {
  posthog.capture('payment_completed', { tripId, amount: 30 });
}

export function trackShareLinkOpened(tripId: string, isAnonymous: boolean) {
  posthog.capture('share_link_opened', { tripId, isAnonymous });
}
